<template>
  <div>
    <div class="heading-4">Manage Wallets</div>
    <wallet-list :filter="filter" class="mt-10" />
    <div class="d-flex justify-end mt-10">
      <c-btn @click="connectWallet">Connect Wallet</c-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WalletList from "./WalletList";

export default {
  components: {
    WalletList,
  },
  computed: mapGetters({
    isAuthenticated: "auth/isAuthenticated",
  }),
  data: () => ({
    filter: {
      network: "",
      type: "",
    },
    showFilter: false,
  }),
  methods: {
    connectWallet() {
      if (this.isAuthenticated) {
        this.$store.dispatch("showSelectWalletModal");
      } else {
        this.$store.dispatch("showAuthModal", "GetStarted");
      }
    },
  },
};
</script>
